var React = require('react');

function NounGraph2281161 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Graph"),React.createElement("path",{"d":"M100.00049,94.999H93.50195v-70.5H71.001v70.5H61.252V47.249H38.751v47.75H29.002v-26H6.501v26H-.00049V100h100.001ZM76.001,29.499h12.501V94H76.001Zm-32.25,22.75H56.252V94.5H43.751Zm-32.25,21.75H24.002V94.5H11.501Z","key":1}),React.createElement("polygon",{"points":"56.168 0 56.168 5 66.234 5 48.217 23.018 25.342 23.018 4.734 43.625 8.271 47.161 27.413 28.018 50.288 28.018 71.001 7.305 71.001 19.833 76.001 19.833 76.001 0 56.168 0","key":2})]);
}

NounGraph2281161.defaultProps = {"height":"100px","width":"100px","fill":"#000000","data-name":"Camada 1","viewBox":"0 0 100 100","x":"0px","y":"0px"};

module.exports = NounGraph2281161;

NounGraph2281161.default = NounGraph2281161;
